import React from "react";

import { EffectiveDatePicker } from "./child/EffectiveDatePicker";
import { ContextHolder } from "./child/ContextHolder";
import { ChangesLoader } from "./child/ChangesLoader";

import { CONTEXT_WORKSPACE } from "../../changesConstants";

interface ChangesHeaderProps {
    context: string;
    workspaceName?: string;
    effectiveDate: string;
    displayLoading?: boolean;
    generated?: string;
    handleEffectiveDateChanged: (validFrom: string) => void;
    handleReloadChanges: (forceReload: boolean) => void;
}

export const ChangesHeader = (props: ChangesHeaderProps) => {
    const {
        context,
        workspaceName,
        effectiveDate,
        displayLoading,
        generated,
        handleEffectiveDateChanged,
        handleReloadChanges,
    } = props;
    return (
        <div className={"changesVisualizationPanelHeader"}>
            <div className={"changesVisualizationPanelHeaderInner"}>
                <ContextHolder context={context} workspaceName={workspaceName!} />

                <EffectiveDatePicker
                    effectiveDate={effectiveDate}
                    disabled={displayLoading || context === CONTEXT_WORKSPACE}
                    onDateChange={handleEffectiveDateChanged}
                />

                <ChangesLoader
                    hidden={context !== CONTEXT_WORKSPACE}
                    dateOfGeneration={generated!}
                    onClick={handleReloadChanges}
                    disabled={displayLoading!}
                />
            </div>
        </div>
    );
};
